import React from 'react';

interface Props {
  size?: number;
}

export default function LoadingSpinner({ size = 40 }: Props): React.ReactElement {
  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 5,
      }}>
        <div style={{
          width: `${size}px`,
          height: `${size}px`,
          border: '4px solid rgba(255, 255, 255, 0.3)',
          borderTop: '4px solid white',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
        }} />
      </div>
    </>
  );
}
